import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Aug 28 2018
 * @author LZe
 */
import * as React from 'react';
import { TextFilter } from 'ag-grid-community';
import Input from '../../../../inputs/Input';

var TextFloatingFilter =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(TextFloatingFilter, _React$PureComponent);

  function TextFloatingFilter() {
    var _this;

    _classCallCheck(this, TextFloatingFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextFloatingFilter).apply(this, arguments));
    _this.state = {
      value: ''
    };

    _this.onChange = function (event) {
      _this.setState({
        value: event.target.value
      }, function () {
        _this.props.onFloatingFilterChanged({
          model: _this.buildModel()
        });
      });
    };

    return _this;
  }

  _createClass(TextFloatingFilter, [{
    key: "onParentModelChanged",
    value: function onParentModelChanged(parentModel) {
      this.setState({
        value: !parentModel ? 0 : parentModel.filter
      });
    }
  }, {
    key: "buildModel",
    value: function buildModel() {
      if (this.state.value === '') {
        return null;
      }

      return {
        type: TextFilter.CONTAINS,
        filter: this.state.value
      };
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Input, Object.assign({}, this.props, {
        onChange: this.onChange,
        placeholder: "Search...",
        tiny: true
      }));
    }
  }]);

  return TextFloatingFilter;
}(React.PureComponent);

export { TextFloatingFilter as default };